import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const userAuthorityMappingMenuRegistry = {
    core_userAuthorityMapping: {
        label: "User Authority Mapping",
        link: PAGE_URL.USER_AUTHORITY_MAPPING_PAGE,
        key: PAGE_URL.USER_AUTHORITY_MAPPING_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default userAuthorityMappingMenuRegistry;
